<button
  type="button"
  class="btn btn-xs btn-outline normal-case rounded-full btn-square"
  [class.pointer-events-none]="isLoadingPreview()"
  (click)="onPreviewDocument()"
  aria-label="Preview document"
>
  @if (isLoadingPreview()) {
  <et-atoms-spinner size="small"></et-atoms-spinner>
  } @else {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    class="w-4 h-4"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
  }
</button>
